import { EmbeddedComponentProps } from "@/interface/base";
import React, { FC } from "react";
import styles from "./size-unit.module.less";

export const SizeUnit: FC<EmbeddedComponentProps> = ({ children }) => (
  <span className={styles.text}> ({children})</span>
);
